import Vue from 'vue'
import Vuex from 'vuex'
import permission from './modules/permission'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    permission,
    user,
  },
  getters:{
    addRouter:state => state.permission.addRouter,
    navMenu:state => state.permission.navMenu,
    userInfo:state => state.user.userInfo,
    perms:state => state.permission.perms,
  }
})
